import { Skeleton } from "@/components/atoms/Skeleton";

const ApplicationRatingSkeleton = () => {
  return (
    <div className="flex flex-col gap-3 basis-1/3">
      <div className="flex items-baseline gap-2">
        <Skeleton className="w-96 h-56 rounded-xl border max-md:w-full" />
      </div>
    </div>
  );
};

export default ApplicationRatingSkeleton;
